import { render } from "./tenantRegister.vue?vue&type=template&id=51b73d6f&scoped=true"
import script from "./tenantRegister.vue?vue&type=script&lang=js"
export * from "./tenantRegister.vue?vue&type=script&lang=js"

import "./tenantRegister.vue?vue&type=style&index=0&id=51b73d6f&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b73d6f"]])

export default __exports__